export default (defaults = [], stats = {}) => {
  return Array.from(
    [...defaults, ...Object.keys(stats)]
      .reduce((brands, key) => {
        const lowerCaseKey = key.toLowerCase()
        if (!brands.has(lowerCaseKey))
          brands.set(lowerCaseKey, {
            key: lowerCaseKey,
            count: stats[lowerCaseKey] || 0
          })
        return brands
      }, new Map())
      .values()
  )
}
